<template>
  <div class="login-main">
    <div class="login-container">
      <el-row type="flex" justify="center">
        <div class="card-lf">
          <div class="top">
            <img src="../../assets/logo.png" alt="">
            <div class="title">
              <h1>娱乐场所治安管理系统</h1>
              <p>Entertainment Place</p>
            </div>
          </div>
          <el-form ref="loginFormRef" status-icon :model="loginForm" :rules="loginFormRules" label-width="0px"
            class="input-div">
            <el-form-item prop="mobile">
              <el-input size="small" v-model.trim.number="loginForm.mobile" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item prop="sms_code">
              <el-input v-model.trim.number="loginForm.sms_code" placeholder="验证码">
              </el-input>
              <button @click.prevent="getCode()" class="code-btn" :disabled="!show">
                <span v-show="show">获取验证码</span>
                <span v-show="!show" class="count">{{ count }} s</span>
              </button>
            </el-form-item>
            <el-form-item prop="password" class="unlook">
              <el-input type="password" v-model="loginForm.password" placeholder="新密码"> </el-input>
            </el-form-item>
            <el-form-item prop="checkPass" class="unlook">
              <el-input type="password" v-model="loginForm.checkPass" placeholder="确认密码"> </el-input>
            </el-form-item>
          </el-form>

          <div class="login-div">
            <div>
              <el-button type="primary" @click="isOk" style="margin: 0;">确认</el-button>
            </div>
            <div>
              <el-button @click="cancel" style="border:0px;color: #6345D5;margin: 0;">取消</el-button>
            </div>
          </div>
          <div class="phone">
            <span>管理员联系方式：{{ phone1 }} <i></i> {{ phone2 }} </span>
          </div>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import { regular } from '@/utils/validate.js'
import * as user from '@/api/user'
export default {

  data() {

    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.loginForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        mobile: '',
        password: '',
        checkPass: '',
        sms_code: '',
      },
      phone1: '029-88413302',
      phone2: '029-88404282',
      show: true,
      timer: 0,
      count: 0,
      loginFormRules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: regular.phone,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ],
        sms_code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],

        password: [
          {
            validator: (rule, value, callback) => {
              //必须包含⼤⼩写字母、数字、特殊字符长度再8-16位之间
              var regex = new RegExp("(?=.*[0-9])(?=.*[a-zA-Z]).{8,16}");
              if (value === "") {
                callback(new Error("请输⼊密码"));
              } else if (value.length < 8 || value.length > 16) {
                callback(new Error("请输⼊8~16位密码"));
              } else if (!regex.test(value)) {
                callback(new Error("密码必须同时包含字母、数字且⾄少8位"));
              } else {
                callback();
              }
            }, trigger: 'change'
          }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],

      }
    }
  },

  methods: {
    isOk() { // 确认
      this.$refs.loginFormRef.validate(async valid => {
        if (!valid) {
          return
        } else {
          const res = await user.savepassword({ ...this.loginForm })
          console.log(res);
          this.$router.push({
            path: '/login'
          })
          this.$message.success('修改成功，请登陆！')
        }

      })
    },
    cancel() { //取消
      this.$router.back(-1)
    },
    forgetpassword() {
      this.$router.push('/forget_password')
    },
    register() {
      this.$router.push('/register')
    },
    getCode() {// 获取验证码
      this.$refs.loginFormRef.validateField('mobile', async (errMsg) => {
        if (errMsg) {
          console.log('校验失败')
          return
        } else {
          await user.getCode(this.loginForm.mobile)
          this.$message.success('发送成功')
        }
        // 验证码倒计时
        if (!this.timer) {
          console.log(this.timer)
          this.count = 30
          this.show = false
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= 30) {
              this.count--;
            } else {
              this.show = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
h2 {
  color: #d5effb;
  margin: 0;
  padding: 0;
}

h4 {
  color: #d3f0fe;
  padding: 10px;
  margin: 0;
}

.login-main {
  background: url(../../assets/img/login_bg.png) no-repeat;
  height: 100%;
  background-size: 100% 100%;
  width: 100%;
}

.login-main .down-app {
  width: 135px;
  top: 20px;
  right: 20px;
  position: absolute;
}

.login-main .down-app>span {
  padding: 10px;
  width: 100%;
  text-align: center;
  color: #b99871;
  font-size: 18px;
  cursor: pointer;
}

.login-main .down-app>img {
  width: 100%;
  height: 100%;
  display: none;
}

.login-container {
  width: 524px;
  height: 683px;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.card-lf {
  background-color: #fff;
  height: 100%;
  width: 100%;
  border-radius: 20px;
  box-shadow: 0px 8px 20px 0px rgba(73, 46, 173, 0.2);

  .top {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 55px;
    margin-top: 40px;

    img {
      width: 55px;
      height: 55px;
    }

    .title {
      h1 {
        margin: 0;
        padding: 0 12px;
        width: 245px;
        font-size: 24px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #3D414F;
      }

      p {
        margin-top: 7px 0 0 8px;
        font-size: 16px;
        font-family: Arial;
        font-weight: bold;
        font-style: italic;
        color: #3D414F;
      }
    }
  }

  .unlook {
    position: relative;

    img {
      position: absolute;
      top: 17px;
      right: 13px;
    }
  }

  .phone {
    width: 100%;
    text-align: center;
    font-weight: 500;
    color: #6345D5;
    font-size: 14px;

    span {
      display: flex;
      justify-content: center;

      i {
        width: 14px;
      }
    }
  }
}

.card-lf p {
  color: #5a86d2;
  padding: 0px;
  font-size: 18px;
  margin: 10px;
  font-weight: 600;
}

.card-rl {
  border: none;
  text-align: center;
  height: 100%;
  position: relative;
  background-color: transparent;
}

.card-rl span {
  top: 45%;
  margin: auto;
  bottom: 0;
  right: 0;
  left: 0;
  position: absolute;
}

.el-row {
  height: 100%;
}

.input-div {
  margin: 40px 50px 0 50px;

  /deep/.el-input__inner {
    position: relative;
    height: 50px;
    padding: 0 20px;
    font-size: 16px;
    border: 1px solid #C1C0D0;
    border-radius: 4px;
  }

  /deep/.code {
    position: absolute;
    right: 0;
    top: 0;
    width: 104px;
    height: 50px;
    background: #6345D5;
    border-radius: 0px 4px 4px 0px;
  }
}

.forget-password-div {
  height: 16px;
  position: relative;
  margin: 0 15px 63px 0;
}

.forget-password-div .forget-password {
  padding: 0px;
  margin: 0px 30px;
  position: absolute;
  top: 0;
  color: #747780;
  font-weight: 500;
  font-size: 16px;
  right: 0;
  text-align: right;
  cursor: pointer;
}

.login-div {
  height: 100px;
  margin: 94px 50px 40px 50px;
  font-weight: 500;

  .el-button--primary {
    background-color: #6345D5;
  }
}

.el-button {
  width: 100%;
  margin-top: 30px;
}

.register-div {
  position: relative;
}

.register-div .register {
  margin: 10px 20px;
  right: 0;
  text-align: right;
  color: #ccc;
  font-size: 12px;
  height: 100%;
}

.register-div .register span {
  color: #5a86d2;
  font-size: 12px;
  display: contents;
  margin-right: 20px;
  padding-right: 20px;
  cursor: pointer;
}

.code-btn {
  width: 100px;
  height: 26px;
  position: absolute;
  top: 10px;
  right: 5px;
  z-index: 222;
  color: #ef8466;
  font-size: 14px;
  border: none;
  border-left: 1px solid #bababa;
  padding-left: 10px;
  background-color: #fff;
  cursor: pointer;
}
</style>
